export default __webpack_public_path__ + "static/media/4_PRESTIGIO_ARABESCATO_120x278_265.a4a50359.jpg";